import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/tailwind.css'
import './styles/rest.css'
import { openGlobalLogin } from '@/common/common'
const app = createApp(App)
const pinia = createPinia()
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus)
app.use(pinia)
app.use(router)
  ; (window as any).openGlobalLogin = openGlobalLogin
app.mount('#container')
